import InitialState from 'constants/InitialState'

var _state = InitialState;

var State = {
  set: function(newState) {
    _state = newState;
  },
  get: function(){
    return _state;
  }
}

export default State
